import { useMutation } from '@tanstack/react-query';
import {loginRequest,changePassword} from './auth.api'
export const useLogin = () => {
    return useMutation({
      mutationFn: loginRequest,
    });
  };
export const useChangePassword = () => {
    return useMutation({
      mutationFn: changePassword,
    });
  };
